import React from 'react';
import { cn } from '../../lib/utils';

export function Label({ className, htmlFor, children, ...props }) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn("text-sm font-medium text-foreground leading-none", className)}
      {...props}
    >
      {children}
    </label>
  );
}
